<main id="main-content" class="main-content">
    <div class="status-list">
        <div class="status-long-item">
            <div class="status-header">TOTAL REQUESTED FUNDS</div>
            <div class="item">{{'$'+(total_req ?? 0 | number:'1.2-2')}}</div>
        </div>
        <div class="status-long-item">
            <div class="status-header">TOTAL RO AUTHORIZED</div>
            <div class="item">{{'$'+(total_ro_auth ?? 0 | number:'1.2-2')}}</div>
        </div>
        <div class="status-long-item">
            <div class="status-header">TOTAL WO AUTHORIZED</div>
            <div class="item">{{'$'+(total_wo_auth | number:'1.2-2')}}</div>
        </div>
        <div class="status-long-item">
            <div class="status-header">TOTAL AUTHORIZED FUNDS</div>
            <div class="item">{{'$'+(total_auth | number:'1.2-2')}}</div>
        </div>
        <!-- 
        <div class="status-long-item">
            <div class="status-header">EXPENDITURES (%)</div>
            <div class="item">{{(((2000)/(summaryInfoSelected.total_auth ?? 0))*100 | number:'1.2-2')+'%'}}</div>
        </div> -->
    </div>
    <h1>Authorized Funds By Report</h1>
    <h3>{{filtered_reports.length ?? 0}} Report(s)</h3>
    <table mat-table [dataSource]="filtered_reports" class="center" matSort matSortDisableClear multiTemplateDataRows>
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Report Name</th>
        <td mat-cell *matCellDef="let report"><a [routerLink]="'/report-overview'"
                [queryParams]="{report_id: report.report_id}">{{report.assessment.baer_name}}({{report.report_num}})</a>
        </td>
        <td mat-footer-cell *matFooterCellDef>Total Funds</td>
    </ng-container>
    <ng-container matColumnDef="action_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Action Type</th>
        <td mat-cell *matCellDef="let report" class="prewrap">
            @if(report.report_num == 0) {
            Pre-Assessment
            } @else if(report.report_num == 1) {
            Initial
            } @else {
            Interim
            }
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="report_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Report Type</th>
        <td mat-cell *matCellDef="let report" class="prewrap">
            @switch (report.report_type) {
            @case ('Emergency Stabilization') {
            Funding Request
            }
            @default {
            {{report.report_type}}
            }
            }
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="total_req">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-right">Requested</th>
        <td mat-cell *matCellDef="let report" class="align-right">{{'$'+(report.total_req ?? 0 | number:'1.2-2') | empty_check}}</td>
        <td mat-footer-cell *matFooterCellDef class="align-right">{{'$'+(total_req | number:'1.2-2') | empty_check}}</td>
    </ng-container>
    <ng-container matColumnDef="ro_auth">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-right">RO Authorized</th>
        <td mat-cell *matCellDef="let report" class="align-right">{{'$'+(report.total_ro_auth ?? 0 | number:'1.2-2') | empty_check}}</td>
        <td mat-footer-cell *matFooterCellDef class="align-right">{{'$'+(total_ro_auth | number:'1.2-2') | empty_check}}</td>
    </ng-container>
    <ng-container matColumnDef="wo_auth">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-right">WO Authorized</th>
        <td mat-cell *matCellDef="let report" class="align-right">{{'$'+(report.total_wo_auth ?? 0 | number:'1.2-2') | empty_check}}</td>
        <td mat-footer-cell *matFooterCellDef class="align-right">{{'$'+(total_wo_auth | number:'1.2-2') | empty_check}}</td>
    </ng-container>
    <ng-container matColumnDef="total_auth">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-right green">Total Authorized</th>
        <td mat-cell *matCellDef="let report" class="align-right green">{{'$'+(report.total_auth ?? 0 | number:'1.2-2') | empty_check}}</td>
        <td mat-footer-cell *matFooterCellDef class="align-right green">{{'$'+(total_auth | number:'1.2-2') | empty_check}}</td>
    </ng-container>
    <ng-container matColumnDef="auth_status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Authorization Status</th>
        <td mat-cell *matCellDef="let report" class="prewrap">
            <mat-chip *ngIf="report.authorization_status_id != null"
                [ngClass]="'chip-a-'+report?.authorization_status_id">
                {{report.authorization_status_id | authorizationStatusBadge}}
            </mat-chip>
            <span *ngIf="report.authorization_status_id == null">--</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="date_auth">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-right">Date Authorized</th>
        <td mat-cell *matCellDef="let report" class="align-right">{{(report.authorized_on | date:"MM/dd/yyyy") || "--" }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns" [hidden]="hide_footer"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="13">
            <div class="no-data">
                <div class="no-data-icon">
                    <img class="no-data-icon3" src="assets/img/empty-state-page.svg" alt="No Reports">
                </div>
                <div class="no-data-title">No Reports Have Been Created</div>
            </div>
        </td>
    </tr>
</table>
</main>